<div class="customer-container">

  <h1>Configure</h1>

  <div class="search-bar">
    <mat-label>Search:</mat-label>
    <input
      matInput
      [formControl]="searchControl"
      placeholder="Search accounts..."
    />
  </div>

<div *ngIf="accounts.length > 0" class="mat-elevation-z8 full-width-table results">
  <mat-expansion-panel
    class="panel"
    *ngFor="let account of accounts"
    (opened)="loadAssets(account, false)"
  >
    <mat-expansion-panel-header>
      <div class="result-item">
        <span class="left">
          {{ account.name }}
        </span>
        <span class="right">
          <button
            mat-raised-button
            color="primary"
            (click)="loadAssets(account, true)"
          >
            <mat-icon>refresh</mat-icon>
          </button>
          <a
            href="https://braxos.my.salesforce.com/{{ account.id }}"
            target="_blank"
            rel="noopener noreferrer"
            (click)="$event.stopPropagation()"
            style="text-decoration: none; color: inherit"
          >
            <img src="sf-small.png" alt="Salesforce" class="sf-image" />
          </a>
        </span>
      </div>
    </mat-expansion-panel-header>

    <ng-container *ngIf="account.assets">
      <mat-list>
        <mat-list-item *ngFor="let asset of account.assets">
          <span class="asset-row">
            <mat-icon
              *ngIf="asset.lastSyncTs"
              [matTooltip]="getAssetTooltip(asset)"
              matTooltipClass="asset-tooltip"
              [style.color]="isOld(asset.lastSyncTs) ? 'red' : 'green'"
              >info</mat-icon
            >

            <span
              class="asset-name"
              [class.grey-text]="asset.family !== 'Steward'"
              >{{ asset.name }} [{{ asset.family }}]</span
            >

            <ng-container *ngIf="asset.family === 'Steward'">
              <button
                mat-icon-button
                matTooltip="Download Plugin..."
                (click)="downloadZip(account.name, asset.id)"
              >
                <mat-icon>download</mat-icon>
              </button>
              <button
                matTooltip="Alerts..."
                *ngIf="asset.masterItemId"
                [disabled]="!(asset.family == 'Steward')"
                mat-icon-button
                (click)="setAlerts(account, asset)"
              >
                <mat-icon>notifications</mat-icon>
              </button>
              <button
                matTooltip="Zabbix Graphs"
                *ngIf="asset.masterItemId"
                mat-icon-button
                (click)="openCharts(asset)"
              >
                <mat-icon>timeline</mat-icon>
              </button>
              <button
                matTooltip="Zabbix Problems"
                *ngIf="asset.masterItemId"
                mat-icon-button
                (click)="openProblems(asset)"
              >
                <mat-icon>report_problem</mat-icon>
              </button>
              <button
                matTooltip="Delete Zabbix Monitors"
                *ngIf="asset.masterItemId"
                mat-icon-button
                (click)="deleteMonitor(account, asset)"
              >
                <mat-icon>delete</mat-icon>
              </button>
              <button
                matTooltip="Create Zabbix Monitors"
                *ngIf="!asset.masterItemId"
                [disabled]="!(asset.family == 'Steward')"
                mat-icon-button
                (click)="createMonitor(account, asset)"
              >
                <mat-icon>call_merge</mat-icon>
              </button>
            </ng-container>
          </span>
        </mat-list-item>
      </mat-list>
      Assets: {{ account.assets.length }}
    </ng-container>
  </mat-expansion-panel>
</div>

</div>
